const coopHelper = {
  isClient () {
    return process.client
  },
  isServer () {
    return process.server
  },
  isStatic () {
    return process.static
  },
  getLoadingOptions () {
    return {
      color: '#FCBF00',
      width: 128,
      height: 128,
      opacity: 0.9,
      zIndex: 9999,
      container: null,
      canCancel: false
    }
  },
  getApiErrorMessage (err) {
    console.log('getApiErrorMessage err: ', err)
    let message = err.message
    if (err.error) {
      message = err.error
      if (message === 'invalid_grant') {
        message = err.error_description
      }
    } else if (err.error_description) {
      message = err.error_description
    }
    if (err.Message) {
      message = err.Message
    }
    if (typeof err === 'string') {
      message = err
    }
    return message
  },
  hashCode (text) {
    let hash = 0
    let i = 0
    let chr = ''
    if (text.length === 0) {
      return hash
    }
    for (i = 0; i < text.length; i++) {
      chr = text.charCodeAt(i)
      hash = ((hash << 5) - hash) + chr
      hash |= 0 // Convert to 32bit integer
    }
    return hash
  },
  getRoomImage (roomId, width = 0, height = 0) {
    let url = `https://nexudus.spaces.nexudus.com/en/publicresources/getimage/${roomId}`
    const query = {}
    if (width > 0) {
      query.w = width
    }
    if (height > 0) {
      query.h = height
    }
    if (Object.keys(query).length > 0) {
      query.anchor = 'middlecenter'
    }
    const q = Object.keys(query)
      .map((key) => {
        return `${key}=${query[key]}`
      })
      .join('&')
    if (q !== '') {
      url += `?${q}`
    }
    return url
  }
  /* listenRipple () {
    // ripple effect
    document.querySelectorAll('[anim="ripple"]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e = e.touches ? e.touches[0] : e
        const r = el.getBoundingClientRect()
        const d = Math.sqrt((r.width ** 2) + (r.height ** 2)) * 2
        el.style.cssText = `--s: 0; --o: 1;`
        // el.offsetTop
        el.style.cssText = `--t: 1; --o: 0; --d: ${d}; --x:${e.clientX - r.left}; --y:${e.clientY - r.top};`
      })
    })
  } */
}

export default ({ app }, inject) => {
  inject('coopHelper', coopHelper)
}
